import {
  Button,
  ButtonGroup,
  closeCurrentDialog,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
} from 'platform/components';
import {Text, VStack} from 'platform/foundation';
import {object, SchemaOf, string} from 'yup';

import i18n from '@dms/i18n';

interface CreateQuickPresetFormType {
  name: string;
  prompt: string;
}

export interface CreateQuickPresetFormProps {
  onSubmit: FormSubmitHandler<CreateQuickPresetFormType>;
}

const schema: SchemaOf<CreateQuickPresetFormType> = object({
  name: string().required(),
  prompt: string().required(),
});

export function CreateQuickPresetForm(props: CreateQuickPresetFormProps) {
  return (
    <Form<CreateQuickPresetFormType> onSubmit={props.onSubmit} schema={schema}>
      {(control, formApi) => (
        <VStack spacing={4}>
          <Text size="xSmall" color="secondary">
            {i18n.t('page.settings.labels.advertisingQuickPresets.createDescription')}
          </Text>
          <FormField
            control={control}
            name="name"
            type="text"
            label={i18n.t('page.settings.labels.advertisingQuickPresets.name')}
            isRequired
          />
          <FormField
            control={control}
            name="prompt"
            type="text"
            label={i18n.t('page.settings.labels.advertisingQuickPresets.prompt')}
            isRequired
          />
          <ButtonGroup align="right">
            <Button
              onClick={closeCurrentDialog}
              isDisabled={formApi.formState.isSubmitting}
              title={i18n.t('general.actions.discard')}
              variant="secondary"
            />
            <FormButton
              type="submit"
              control={control}
              title={i18n.t('general.actions.save')}
              isDisabled={formApi.formState.isSubmitting}
              isLoading={formApi.formState.isSubmitting}
            />
          </ButtonGroup>
        </VStack>
      )}
    </Form>
  );
}
